import { render, staticRenderFns } from "./DisclosureAction.vue?vue&type=template&id=308a3daa"
import script from "./DisclosureAction.vue?vue&type=script&lang=ts"
export * from "./DisclosureAction.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports